import { GetConditionReq, GetConditionRes } from '@gateway.Simulation'
import { yamadumiApi } from '../yamadumi-api'
/**
 * 検索条件-取得API
 */
export class GetConditionGateway {
  static getCondition = async (params: GetConditionReq) => {
    return await yamadumiApi.get<GetConditionRes>('/api/common/condition', { ...params })
  }
}
